var rich_content_viewer_default = {
  "fontElementMap": "y-LZ9",
  "wrapper": "FG6wk",
  "pluginContainerMobile": "ZcoCX",
  "viewer": "t6D-Y",
  "android": "IpAAy",
  "rootedTraversedContent": "M3ZrQ",
  "atomic": "hqJKn",
  "toolbar": "-sVP1",
  "block": "r7gT8"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
